import React, { useEffect } from "react";
import "./style.css";

export const Element = () => {
  useEffect(() => {
    document.body.style.transform = `scale(${window.innerWidth / 1920})`;
    document.body.style.transformOrigin = `top left`;
  });

  return (
    <div className="element">
      <div className="div">
        <div className="intro">
          <div className="group">
            <div className="text-wrapper">CONCELIUM</div>
            <div className="text-wrapper-2">®</div>
          </div>
          <div className="corporate-financial">
            Corporate &amp; Financial Services
          </div>
          <div className="text-wrapper-3">Website + CMS</div>
          <img className="image" alt="Image" src="/img/image.png" />
          <div className="context">
            <div className="text-wrapper-4">Web Design</div>
            <p className="conselium-is-a">
              Conselium is a financial and strategic advisory firm <br />
              that offers wealth and financial management services <br />
              to enterprises, businesses and individuals. We helped them
              redesign their website structure and architecture with more
              emphasis on the brand and set a unified style <br />
              while keeping it clean, functional, and user-friendly.
            </p>
          </div>
          <div className="scope-of-work">
            <div className="overlap">
              <img className="UIX" alt="Uix" src="/img/uix.png" />
              <div className="SM">
                <div className="overlap-group">
                  <div className="text-wrapper-5">Content</div>
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group-2">
                      <img className="line" alt="Line" src="/img/line-18.svg" />
                      <img className="img" alt="Line" src="/img/line-19.svg" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-wrapper-6">Scope of Work</div>
            </div>
            <div className="WD">
              <div className="overlap-2">
                <div className="text-wrapper-7">Web Development</div>
                <div className="overlap-group-wrapper">
                  <div className="overlap-group-2">
                    <img className="line" alt="Line" src="/img/line-18-1.svg" />
                    <img className="img" alt="Line" src="/img/line-19-1.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="overlap-3">
          <div className="overlap-4">
            <img className="website" alt="Website" src="/img/website.png" />
            <div className="frame">
              <img className="mobile" alt="Mobile" src="/img/mobile.png" />
            </div>
          </div>
          <img
            className="mask-group"
            alt="Mask group"
            src="/img/mask-group-1.png"
          />
        </div>
        <div className="outro">
          <div className="div-wrapper">
            <div className="logo-wrapper">
              <img className="logo" alt="Logo" src="/img/logo.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
